import { useEffect, useState, MouseEvent } from 'react'
import { BackButton, Breadcrums, MUIFieldWithoutControl } from '../../Shared'
import HeaderComponent from '../../Atoms/HeaderComponent'
import CONSTANTS, { BREADCRUMS, PAGES_ROUTES } from '../../../Constants'
import styles from '../../ManageWidget/ManageWidget.module.scss'
import { useParams, useNavigate } from 'react-router-dom'
import {
  combineErrorMessage,
  getHeaderData,
  getPageName,
  handleResponse,
  toCamelCase,
} from '../../../Helpers/Util'
import { useAppDispatch } from '../../../Store/Hooks'
import { getWidgetDetailById } from '../../../Store/Slice/manage-widget.slice'
import {
  getContainerDetailById,
  setParentContainerDetail,
} from '../../../Store/Slice/manage-container.slice'
import { getDetailById } from '../../../Store/Slice/site-navigation.slice'
import { IKeyValue } from '../../../Models/CommonListHeadingModal'
import ListingComponent from '../ListingComponent'
import { Tablecolumn } from '../../../Models'
import mainApiService from '../../../Services'
import { showAlert } from '../../../Store/Slice/alert.slice'
import {
  ASSOCIATED_LIST,
  BULK_OPERATIONS,
  CONTAINER_MANAGEMENT_CRUD,
  IRIS_SEGMENT,
  SITE_NAVIGATION_CRUD,
  WIDGET_MANAGEMENT_CRUD,
} from '../../../Constants/ApiDefinations'
import { getMasterByKey } from '../../../Store/Slice/system-configuration.slice'
import { ASSOCIATED_ITEMS, MODULE_CONSTANTS } from '../../../Constants/Texts'
import { viewSegmentService } from '../../../Store/Slice/segment.slice'
import { viewParameterService } from '../../../Store/Slice/parameter.slice'
import { InputAdornment } from '@mui/material'
import { Search } from '@mui/icons-material'
import useDebounce from '../../../Hooks/useDebounce'
import {
  ListingData,
  getAssociationModulePayload,
  getDocumentTitle,
  getFilterOptions,
  getSearchPlaceholder,
  getTabConfig,
  isAssetOpsModule,
  isIrisSegmentModule,
  transformListingRecords,
} from './utils'
import HTTP_STATUS_CODE from '../../../Constants/HttpStatusCode'

const AssociatedItems = () => {
  const { module, id } = useParams()
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const [detailData, setDetailData] = useState<any>({})
  const [selectedTabs, setSelectedTabs] = useState({ key: '', value: '' })
  const [tabs, setTabs] = useState<IKeyValue[]>([])
  const [columnData, setColumnData] = useState<Tablecolumn[]>([])
  const [listData, setListData] = useState<any[]>([])
  const [dataCount, setDataCount] = useState(0)
  const [listingProperty, setListingProperty] = useState<ListingData>({
    redirectViewAPiRouteMidPoint: '',
    entityType: '',
    displayName: '',
  })
  const [headerLabel, setHeaderLabel] = useState('')
  const [clearColumnFilter, setClearColumnFilter] = useState<boolean>(false)
  const [listFilter, setListFilter] = useState<any>([])
  const [isLoader, setIsLoader] = useState<boolean>(true)
  const [listingApiCall, setListingApiCall] = useState(false)
  const [searchFunctionFilters, setSearchFunctionFilters] = useState<{
    sortBy: string | number
    filterValue: string
    sortType: number
    page: number
    limit: number
    filters: any
  }>({ sortBy: '', filterValue: '', sortType: 0, page: 1, limit: 10, filters: [] })
  const [searchInput, setSearchInput] = useState('')
  const searchValue = useDebounce(searchInput, 1000)

  useEffect(() => {
    getDetailDataAccToModule()
  }, [module, id])

  useEffect(() => {
    if (Object.keys(detailData).length > 0 && selectedTabs.key) {
      setSearchFunctionFilters((prev) => ({
        ...prev,
        filterValue: searchValue,
        page: 1,
      }))
    }
  }, [searchValue])

  useEffect(() => {
    if (tabs.length > 0) {
      setSelectedTabs(tabs[0])
    }
  }, [tabs])

  useEffect(() => {
    document.title = getDocumentTitle(detailData, module)
  }, [
    module,
    detailData?.segmentName,
    detailData?.parameterName,
    detailData?.title,
    detailData?.jobName,
    detailData?.jobId,
    detailData?.value,
    detailData?.key,
  ])

  useEffect(() => {
    const selectedTabsKey = selectedTabs.key
    if (selectedTabsKey) {
      getLayoutAndState()
      setListData([])
      const config = getTabConfig(selectedTabsKey, module === 'parameter-repository')
      if (config) {
        setColumnData(config.columns)
        setListingProperty(config.listDetail)
      }
      setClearColumnFilter(true)
      setListingApiCall(true)
    }
  }, [selectedTabs, module])

  const getDetailDataAccToModule = async () => {
    if (!module || !id) return
    let listDetail: ListingData | undefined
    let resultData: any

    if (isAssetOpsModule(module)) {
      const requestedData = BULK_OPERATIONS.GET_JOB_DETAIL({ jobId: id, jobType: 'asset_ops' })
      const res: any = await mainApiService(requestedData)
      const record = res?.data?.[0] || res?.payload?.data || {}
      resultData = {
        ...record,
        jobId: record?.jobId || id,
        jobName: record?.jobName || 'NA',
      }
      setTabs(ASSOCIATED_ITEMS.ASSOCIATED_TABS.slice(0, 1))
      setHeaderLabel('Asset Operations')
      listDetail = {
        redirectViewAPiRouteMidPoint: PAGES_ROUTES.ManageWidget,
        entityType: 'widget',
        displayName: 'widget',
      }
    } else if (isIrisSegmentModule(module)) {
      const requestedData = IRIS_SEGMENT.DETAIL_IRIS_SEGMENT(id)
      const res: any = await mainApiService(requestedData)
      const records = res?.data || []
      resultData = records
      setTabs(ASSOCIATED_ITEMS.ASSOCIATED_SEGMENT_TABS)
      setHeaderLabel('IRIS Segment')
      listDetail = {
        redirectViewAPiRouteMidPoint: PAGES_ROUTES.ManageSegment,
        entityType: 'segment',
        displayName: 'segment',
      }
    } else {
      switch (module) {
        case CONSTANTS.ASSOCIATED_MODULE_WIDGET: {
          const res = await dispatch(getWidgetDetailById(id) as any)
          resultData = res?.payload?.data
          setTabs(ASSOCIATED_ITEMS.ASSOCIATED_TABS)
          setHeaderLabel('Widget')
          listDetail = {
            redirectViewAPiRouteMidPoint: PAGES_ROUTES.ManageContainer,
            entityType: 'container',
            displayName: 'container',
          }
          break
        }
        case CONSTANTS.ASSOCIATED_MODULE_SEGMENT: {
          const res = await dispatch(viewSegmentService(id) as any)
          resultData = res?.payload?.data
          setTabs(ASSOCIATED_ITEMS.ASSOCIATED_TABS)
          setHeaderLabel('Segment')
          listDetail = {
            redirectViewAPiRouteMidPoint: PAGES_ROUTES.ManageContainer,
            entityType: 'container',
            displayName: 'container',
          }
          break
        }
        case CONSTANTS.ASSOCIATED_MODULE_PARAMETER_REPOSITORY: {
          const res = await dispatch(viewParameterService(id) as any)
          resultData = res?.payload?.data
          setTabs(ASSOCIATED_ITEMS.ASSOCIATED_TABS)
          setHeaderLabel('Parameter')
          listDetail = {
            redirectViewAPiRouteMidPoint: `${PAGES_ROUTES.BoltMaster}/${PAGES_ROUTES.ContainerDefinitionList}`,
            entityType: 'container',
            displayName: 'container',
          }
          break
        }
        case CONSTANTS.ASSOCIATED_MODULE_SITENAVIGATION: {
          const res = await dispatch(getDetailById(id) as any)
          resultData = res?.payload?.data
          setTabs(
            ASSOCIATED_ITEMS.ASSOCIATED_TABS.slice(2, ASSOCIATED_ITEMS.ASSOCIATED_TABS.length),
          )
          setHeaderLabel('Widget')
          listDetail = {
            redirectViewAPiRouteMidPoint: PAGES_ROUTES.SiteNavigation,
            entityType: module,
            displayName: module,
          }
          break
        }
        case CONSTANTS.ASSOCIATED_MODULE_CONTAINER: {
          const res = await dispatch(getContainerDetailById({ id, containerId: id }) as any)
          resultData = res?.payload?.data
          setTabs(
            ASSOCIATED_ITEMS.ASSOCIATED_TABS.slice(1, ASSOCIATED_ITEMS.ASSOCIATED_TABS.length),
          )
          setHeaderLabel('Container')
          listDetail = {
            redirectViewAPiRouteMidPoint: PAGES_ROUTES.ManageWidget,
            entityType: 'widget',
            displayName: 'widget',
          }
          break
        }
        default:
          break
      }
    }

    setDetailData(resultData || {})
    if (listDetail) setListingProperty(listDetail)
  }

  const getLayoutAndState = async () => {
    const result = await dispatch(getMasterByKey('keyName=STATES') as any)
    let requestedData: any
    let initialResult: any
    switch (selectedTabs.key) {
      case 'widget': {
        requestedData = WIDGET_MANAGEMENT_CRUD.LAYOUT.LIST('excludeSiteNavigationLayouts=true')
        initialResult = await mainApiService(requestedData)
        setListFilter([
          getFilterOptions(
            'type',
            ASSOCIATED_ITEMS.LISTING.FILTERS.TYPE,
            initialResult?.data?.Types,
          ),
          getFilterOptions(
            'layout',
            ASSOCIATED_ITEMS.LISTING.FILTERS.LAYOUT,
            initialResult?.data?.Layouts,
          ),
          getFilterOptions('state', ASSOCIATED_ITEMS.LISTING.FILTERS.STATE, result?.payload?.data),
        ])
        break
      }
      case 'container': {
        requestedData = CONTAINER_MANAGEMENT_CRUD.LAYOUT.LIST('')
        initialResult = await mainApiService(requestedData)
        setListFilter([
          getFilterOptions(
            'layout',
            ASSOCIATED_ITEMS.LISTING.FILTERS.LAYOUT,
            initialResult?.data?.Layouts,
          ),
          getFilterOptions('state', ASSOCIATED_ITEMS.LISTING.FILTERS.STATE, result?.payload?.data),
        ])
        break
      }
      case 'siteNavigation': {
        requestedData = SITE_NAVIGATION_CRUD.LAYOUTS_LISTING('type=Menu Items')
        const assetLayoutsData = await mainApiService(requestedData)
        if (assetLayoutsData?.data?.records?.length > 0) {
          initialResult = {
            data: {
              Layouts: assetLayoutsData.data.records.map((type: any) => ({
                key: type.layout,
                value: type.layout,
              })),
            },
          }
        }
        setListFilter([
          getFilterOptions(
            'layout',
            ASSOCIATED_ITEMS.LISTING.FILTERS.LAYOUT,
            initialResult?.data?.Layouts,
          ),
          getFilterOptions(
            'state',
            ASSOCIATED_ITEMS.LISTING.FILTERS.STATE,
            result?.payload?.data,
            false,
          ),
        ])
        break
      }
      default: {
        break
      }
    }
  }

  const handleOnNavigation = () => {
    navigate(-1)
  }

  const handleTabSelection = (e: MouseEvent<HTMLDivElement>, tab: IKeyValue) => {
    e.preventDefault()
    setSelectedTabs(tab)
  }

  const displayTabs = () => {
    if (tabs?.length > 0) {
      return tabs.map((tab) => {
        const isSelectedTab = tab.key === selectedTabs?.key
        return (
          <div
            className='font-semibold'
            key={toCamelCase(tab.key)}
            aria-hidden='true'
            onClick={(e) => handleTabSelection(e, tab)}
            style={{
              padding: '0.75rem 1.5rem',
              color: isSelectedTab ? '#402080' : '#3E3F40',
              background: isSelectedTab ? '#ECE9F2' : 'transparent',
              borderRadius: isSelectedTab ? '0.25rem 0.25rem 0 0' : 0,
              borderBottom: isSelectedTab ? '2px solid #402080' : 0,
              cursor: 'pointer',
            }}
          >
            {tab.value}
          </div>
        )
      })
    }
  }

  const isFiltersPresent = () => {
    const exculdFilters = ['iris-segment']
    if (!module) return
    else if (exculdFilters.includes(module)) {
      return false
    }
    return true
  }

  const getWidgetListFunction = async (options: any) => {
    const { moduleDataName, modulePayloadName } = getAssociationModulePayload(module)
    const contentId = detailData?.[moduleDataName]?.toString()
    const filtersPayload = isFiltersPresent() ? options?.filters : []

    const payload: any = {
      filters: filtersPayload,
      sortType: options.sortType ? options.sortType : -1,
      page: options.page ? options.page : 1,
      limit: options.limit ? options.limit : 10,
      associationInfo: {
        module: modulePayloadName,
        contentId,
        tab: selectedTabs.key,
      },
    }
    if (options.sortBy) {
      payload.sortBy = options.sortBy
    }
    if (options.filterValue) {
      payload.searchText = options.filterValue
    }
    if (selectedTabs.key === MODULE_CONSTANTS.CONTAINER) {
      const parameterName = CONSTANTS.ASSOCIATED_CONTAINER_LISTING_COLUMNS.map(
        (data: any) => data.id,
      )
      payload.selectedParameters = [...parameterName, 'contentListingPage']
    }
    setIsLoader(true)

    let requestedData: any = {}
    if (module === 'parameter-repository') {
      delete payload.filters
      delete payload.associationInfo.module
      delete payload.associationInfo.contentId
      payload.associationInfo.parameterId = detailData?._id
      requestedData = ASSOCIATED_LIST.ASSOCIATED_PARAMETER_LISTING(payload)
    } else {
      requestedData = ASSOCIATED_LIST.LISTING(payload)
    }
    const result: any = await mainApiService(requestedData)
    const { responseCode } = handleResponse(result)
    if (result?.responseCode === HTTP_STATUS_CODE.OK) {
      const tempData = transformListingRecords(
        selectedTabs.key,
        listingProperty.redirectViewAPiRouteMidPoint,
        result?.data?.records,
      )
      setDataCount(result?.data?.count)
      setListData(tempData)
      setIsLoader(false)
    } else if (responseCode === HTTP_STATUS_CODE.NOT_FOUND) {
      setDataCount(0)
      setListData([])
      setIsLoader(false)
    } else {
      dispatch(showAlert([true, combineErrorMessage(result), 'error']))
      setIsLoader(false)
    }
  }

  const handleOnRowClick = (event: any) => {
    if (selectedTabs.key === MODULE_CONSTANTS.CONTAINER) {
      dispatch(setParentContainerDetail({ containerId: event?._id ?? '', data: event }))
    }
  }

  const getHeaderComponent = () => {
    if (isAssetOpsModule(module)) {
      return (
        <HeaderComponent
          headerData={getHeaderData(detailData, module)}
          showAccordionIcon={false}
          dynamicHeaderFirstRow={[
            {
              title: 'Job ID',
              value: detailData?.jobId || detailData?.contentId || id || 'NA',
            },
            {
              title: 'Job Name',
              value: detailData?.jobName || 'NA',
            },
          ]}
        />
      )
    }

    switch (module) {
      case 'segment':
        return (
          <HeaderComponent
            headerData={getHeaderData(detailData, module)}
            dynamicHeaderFirstRow={[
              {
                title: `${headerLabel} Name`,
                value: detailData?.segmentName || 'NA',
                maxCount: 25,
              },
              {
                title: 'Segment Description',
                value: detailData?.description || 'NA',
                maxCount: 100,
                toolTipWidth: '350px',
              },
            ]}
          />
        )

      case 'iris-segment':
        return (
          <HeaderComponent
            headerData={getHeaderData(detailData, module)}
            status={detailData?.status || detailData?.irisStatus}
            dynamicHeaderFirstRow={[
              {
                title: 'Key',
                value: detailData?.key || 'NA',
                maxCount: 40,
              },
              {
                title: 'Value',
                value: detailData?.value || 'NA',
                maxCount: 40,
              },
            ]}
          />
        )

      case 'parameter-repository':
        return (
          <HeaderComponent
            headerData={getHeaderData(detailData, module)}
            dynamicHeaderFirstRow={[
              {
                title: 'Parameter Name',
                value: detailData?.parameterName || 'NA',
              },
              { title: 'Data Type', value: detailData?.dataType || 'NA' },
              {
                title: 'Field Type',
                value: detailData?.fieldType || 'NA',
              },
            ]}
          />
        )

      default:
        return (
          <HeaderComponent
            headerLabel={headerLabel}
            status={detailData?.stateDisplayName}
            type={detailData?.type}
            layout={detailData?.layout}
            title={detailData?.title}
            headerData={getHeaderData(detailData, module)}
          />
        )
    }
  }

  useEffect(() => {
    if (Object.keys(detailData).length > 0 && selectedTabs.key) {
      getWidgetListFunction(searchFunctionFilters)
      setListingApiCall(false)
    }
  }, [searchFunctionFilters])

  return (
    <div style={{ padding: '1rem 1.875rem', height: '100vh' }}>
      <div className={styles['breadcrums']} style={{ marginBottom: '0.75rem' }}>
        <Breadcrums
          isMarginTop={false}
          breadcrums={BREADCRUMS.ASSOCIATED_ITEMS(getPageName(module)) as any}
        />
      </div>
      <div
        className='d-flex align-items-center justify-content-between'
        style={{ marginBottom: '1rem' }}
      >
        <div className={styles['back-btn']} style={{ marginBottom: 0 }}>
          <BackButton
            label={ASSOCIATED_ITEMS.LINK_CTA}
            className='col73'
            handleOnClick={() => handleOnNavigation()}
          />
        </div>
        <MUIFieldWithoutControl
          className='c-input listing-search'
          name='outlined-search'
          onChange={(e: any) => {
            setSearchInput(e)
          }}
          placeholder={getSearchPlaceholder(module)}
          value={searchInput}
          label=''
          inputProps={{ 'data-testid': 'associated-items-search' }}
          autoComplete='off'
          showClearIcon
          InputProps={{
            id: 'associatedItemsSearchId',
            startAdornment: (
              <InputAdornment position='start'>
                <Search style={{ color: '#B1B4B6' }} />
              </InputAdornment>
            ),
          }}
        />
      </div>
      <div className={styles['background']}>
        <div className='w-100' style={{ marginBottom: '1.5rem' }}>
          {getHeaderComponent()}
        </div>
      </div>
      <div className='w-100'>
        <div className='d-flex' style={{ gap: '1rem', backgroundColor: 'white' }}>
          {displayTabs()}
        </div>

        <ListingComponent
          columns={columnData}
          tableRows={listData}
          dataCount={dataCount}
          isLoading={isLoader}
          showSearchField={false}
          headerAddon
          handleClearAllFilters={() => {
            setSearchFunctionFilters((pre) => ({
              ...pre,
              filters: [],
              page: 1,
            }))
            dispatch(showAlert([true, 'All filters cleared', 'success']))
          }}
          showCreateButton={false}
          noDataPlaceHolder={`No ${listingProperty.displayName} is associated`}
          showAdvanceFilter={true}
          clearFilterValues={clearColumnFilter}
          filterValuesCleared={(value: boolean) => setClearColumnFilter(!value)}
          searchFunction={(search, sorttype, coltype, filters, pagenumber, pagecount) => {
            if (Object.keys(detailData).length > 0 && selectedTabs.key) {
              setSearchFunctionFilters((pre) => ({
                ...pre,
                filters: filters,
                sortBy: coltype,
                sortType: sorttype,
                page: pagenumber,
                limit: pagecount,
                filterValue: searchValue,
              }))
            }
          }}
          isAssociatedList={true}
          handleRowClick={(event) => handleOnRowClick(event)}
          paginationOption={CONSTANTS.PAGINATION_OPTIONS}
          showFilterOptions={headerLabel !== 'Parameter' && !isIrisSegmentModule(module)}
          showVersionColumn={module !== 'parameter-repository' && !isIrisSegmentModule(module)}
          entityType={listingProperty?.entityType}
          filterFields={listFilter}
          shouldSearchFunctionCall={listingApiCall}
        />
      </div>
    </div>
  )
}

export default AssociatedItems
